import { theme } from 'src/styles/themes/default'

export const buttonCursor = (active: boolean) =>
  active ? 'default' : 'pointer'

export const buttonBorder = (active: boolean) =>
  active ? `0.094rem solid ${theme.primary.main}` : '0.094rem solid #DCDDE3'

export const buttonContentColor = (active: boolean) =>
  active ? theme.primary.main : '#7C8096'
